// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ebWk","name":"styles_name__14UDU","phone":"styles_phone__5xPjx"};